// ACTION CREATORS
import {
    SET_CART_ITEMS_DATA,
    SET_CART_IMAGES_DATA,
    SET_CART_DETAILS,
    SET_COUPON,
    EMPTY_CART,
} from "redux/actions/constants/action-types";

// ALL FUNCTIONS
export function setCartItem(cartDataArray) {
    return {
        type: SET_CART_ITEMS_DATA,
        payload: cartDataArray,
    };
}

export function setCartImages(cartData) {
    return {
        type: SET_CART_IMAGES_DATA,
        payload: cartData,
    };
}

export function setCartDetails(cartDetails) {
    return {
        type: SET_CART_DETAILS,
        payload: cartDetails,
    };
}

export function setAppliedCoupon(coupon) {
    return {
        type: SET_COUPON,
        payload: coupon,
    };
}

export function emptyCart() {
    return {
        type: EMPTY_CART,
        payload: "user log out",
    };
}
